import { createContext, ReactNode, useContext, useReducer } from "react";
import { InitialContext } from "../../../../types/state/context";
import { ArtworkApprovalsReducer } from "../../state/approvals";
import {
  ArtworkApprovalRequestTypes,
  ArtworkApprovalsState,
} from "../../state/approvals/data.type";



type Context = InitialContext<ArtworkApprovalsState, ArtworkApprovalRequestTypes>;

export const ArtworkApprovalContext = createContext<Context>({} as Context);

export function ApprovalContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [state, dispatch] = useReducer(
    ArtworkApprovalsReducer.reducer,
    ArtworkApprovalsReducer.initialState,
  );

  return (
    <ArtworkApprovalContext.Provider value={{ state, dispatch }}>
      {children}
    </ArtworkApprovalContext.Provider>
  );
}

export const useArtworkApprovalContextStore = () =>
  useContext(ArtworkApprovalContext);
